import { Eye } from '@phosphor-icons/react';

export default Eye;
